import { nation_to_cCode } from "../Utils/numberUtils.js";

const formatDate = (date) => {
  if (!date) return null;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const departmentNameToId = (departmentName, departmentList) => {
  if (departmentName === null || departmentName === "전체 부서") {
    return "__all__";
  }

  if (departmentName === "없음") {
    return "__none__";
  }

  const found = departmentList.find(
    (department) => department.departmentName === departmentName
  );

  return found ? found.companyDepartmentId : "__all__";
};

const getMemberFilterDateRange = ({ startTime, endTime }) => {
  const today = new Date();

  return {
    startTime: formatDate(startTime ?? today),
    endTime: formatDate(endTime ?? today),
  };
};

export const buildMemberFilterParams = ({
  searchWord,
  startTime,
  endTime,
  sortForMember,
  nationForMember,
  status,
  departmentForMember,
  departmentList,
  emptyCCode = null,
  includeDepartmentFilter = false,
}) => {
  const { startTime: filterStartTime, endTime: filterEndTime } =
    getMemberFilterDateRange({
      startTime,
      endTime,
    });

  const params = {
    searchTitle: searchWord,
    startTime: filterStartTime,
    endTime: filterEndTime,
    sort: sortForMember === "랭킹순" ? "rank" : "",
    cCode: nation_to_cCode(nationForMember) ?? emptyCCode,
    status,
  };

  if (includeDepartmentFilter) {
    params.departmentFilter = departmentNameToId(
      departmentForMember,
      departmentList
    );
  }

  return params;
};
